import React, {useEffect, useState} from "react";
import {
    addNewRowToTable,
    convertCurrencyFormatPositiveNegative, convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput, RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoTableTitleContainer,
    showErrorMessage,
    RaikoCustomSimpleChip,
    RaikoChipTypes
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import {useDebounce} from "@uidotdev/usehooks";
import {useNavigate, useSearchParams} from "react-router-dom";
import {addFiltersToUrl} from "../../util/FiltersHelper";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import AddNewGroup from "./AddNewGroup";

export default function Groups() {

    const [searchParam, setSearchParam] = useSearchParams();
    const [page, setPage] = useState(searchParam.get("page") || 1);
    const size = 20

    const navigate = useNavigate()

    const [groupName, setGroupName] = useState(searchParam.get("group-name") || "")
    const [groupCode, setGroupCode] = useState(searchParam.get("group-code") || "");

    const filterGroupName = useDebounce(groupName, 300)
    const filterGroupCode = useDebounce(groupCode, 300)

    const [tableLoading, setTableLoading] = useState(true)
    const [groupsItems, setGroupsItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);


    const service = new GroupsService()

    const {fundID} = useAuthState()


    useEffect(() => {
        if (typeof filterGroupName !== "undefined" && typeof filterGroupCode !== 'undefined') {
            getDataFromServer()
            prepareFiltersParam()
        }
    }, [
        filterGroupName,
        filterGroupCode,
        page,
        fundID
    ]);

    function prepareFiltersParam() {
        const filters = []

        if (page && page > 1)
            filters.push(`page=${page}`)
        if (groupName && groupName.length > 0)
            filters.push(`group-name=${filterGroupName}`)
        if (groupCode && groupCode.length > 0)
            filters.push(`group-code=${groupCode}`)

        navigate(addFiltersToUrl(filters))
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getGroups(
            fundID,
            page > 0 ? page - 1 : 0,
            size,
            groupName,
            groupCode
        ).then(groupData => {

            setTotalItems(groupData.numberOfItems)
            setPageCount(groupData.totalPage)
            setGroupsItems([])

            groupData.data.map((item, index) => {
                const teamLeader = `${item.groupLeader ? item.groupLeader.firstName : ""} ${item.groupLeader ? item.groupLeader.lastName : ""}`

                setGroupsItems((prevState => [...prevState,
                    prepareGroupsJsonList(
                        item.id,
                        (page * size) + index + 1,
                        item.code,
                        item.name,
                        item.summationOfDepositAccountsBalance,
                        item.numberOfDepositAccounts,
                        item.summationOfLoans,
                        item.numberOfLoans,
                        item.numberOfMembers,
                        item.createdAt,
                        teamLeader.length > 2 ? teamLeader : "-",
                        item.enabled
                    )
                ]))
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleShowDetail(id) {
        let title = ""
        groupsItems.map((item) => {
            if (item.id === id)
                title = item.name
        })

        navigate(
            RouteHelper.GroupsDetail.globalUrl.replace(":id", id),
            {state: {title: title}, replace: false}
        )
    }

    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }


    function prepareGroupsJsonList(
        id, number, code, name, inventory, numberOfDepositAccounts,
        summationOfLoans, numberOfLoans, numberOfMembers, createdDate, teamLeader, enabled) {
        return {
            id: id,
            number: number,
            code: code,
            name: name,
            loanAmount: summationOfLoans ? convertCurrencyFormatPositiveNegative(summationOfLoans) : "0",
            numberOfLoans: numberOfLoans ? convertCurrencyFormatPositiveNegative(numberOfLoans) : "0",
            numberOfDepositAccounts: numberOfDepositAccounts ? convertCurrencyFormatPositiveNegative(numberOfDepositAccounts) : "0",
            userCount: numberOfMembers ? convertCurrencyFormatPositiveNegative(numberOfMembers) : "0",
            cash: inventory ? convertCurrencyFormatPositiveNegative(inventory) : 0,
            createdDate: createdDate ? convertUniversalDateTimeToPersianDateTime(createdDate) : "-",
            teamLeader: teamLeader,
            state: enabled ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                :
                <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        };
    }


    const [openDialogState, setOpenDialogState] = useState(false)
    const handleOpenDialog = () => setOpenDialogState(true)
    const handleCloseDialog = () => setOpenDialogState(false)

    function handleAddNewItemToTable(item) {
        const teamLeader = `${item.groupLeader ? item.groupLeader.firstName : ""} ${item.groupLeader ? item.groupLeader.lastName : ""}`

        const newItems = addNewRowToTable(
            prepareGroupsJsonList(
                item.id,
                1,
                item.code,
                item.name,
                item.summationOfDepositAccountsBalance,
                item.numberOfDepositAccounts,
                item.summationOfLoans,
                item.numberOfLoans,
                item.numberOfMembers,
                item.createdAt,
                teamLeader.length > 2 ? teamLeader : "نامشخص",
                item.enabled
            ),
            groupsItems
        )

        setGroupsItems(newItems)
        handleCloseDialog()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialogState}
                pageTitle={"افزودن گروه جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <AddNewGroup
                    handleAddNewItemToTable={handleAddNewItemToTable}
                />
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.GroupsList.name,
                            RouteHelper.GroupsList.globalUrl
                        )
                    ]}/>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridTwoColumn>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام گروه"}
                                    value={groupName}
                                    setValue={value => {
                                        setPage(1)
                                        setGroupName(value)
                                    }}
                                />
                                <RaikoNumberInputOutlined
                                    labelText={"کد گروه"}
                                    value={groupCode}
                                    setValue={value => {
                                        setPage(1)
                                        setGroupCode(value)
                                    }}
                                />
                            </RaikoGridTwoColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"گروه ها"}
                                amount={totalItems}
                                amountTitle={"گروه"}
                                hasCreateNewItem
                                createNewItemTitle={"افزودن"}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={headers}
                                data={groupsItems}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                rowClicked={handleShowDetail}
                                handlePaginationChange={handleChangePagination}
                                newPage={pageCount}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>


                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}


const headers = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'code',
        label: 'کد',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام',
        align: 'right',
    },
    {
        id: 'cash',
        label: 'مجموع پس انداز (ریال)',
        align: 'right',
    },
    {
        id: 'numberOfLoans',
        label: 'تعداد وام ها',
        align: 'right',
    },
    {
        id: 'loanAmount',
        label: 'مجموع وام ها (ریال)',
        align: 'right',
    },
    {
        id: 'userCount',
        label: 'اعضا',
        align: 'right',
    },
    {
        id: 'numberOfDepositAccounts',
        label: 'تعداد حساب ها',
        align: 'right',
    },
  /*  {
        id: 'createdDate',
        label: 'تاریخ ساخت',
        align: 'right',
    },*/
    {
        id: 'teamLeader',
        label: 'سرگروه',
        align: 'right',
    },
    {
        id: 'state',
        label: 'وضعیت',
        align: 'right',
    },
]
